<div class="main-wrapper" [class.pd-0]="!showHeader && headerType != 'site'" [dir]="textDirection" [class.arebic-font]="textDirection == 'rtl'">

    <ng-container *ngIf="headerType == 'site'; else checkout">
        <div class="page-header">
            <taly-site-header />
        </div>
    </ng-container>

    <ng-template #checkout>
        <taly-header *ngIf="showHeader"/>
    </ng-template>
   
    <main class="page-body">
        <router-outlet />
    </main>
    <footer *ngIf="showFooter" class="page-footer">
        <taly-footer />
    </footer>

    <p-toast position="bottom-center"></p-toast>
    <taly-user-idle />

</div>
<!-- 
<div class="apple-pay">
    <div #applePayButton id="apple-pay-button"></div>
</div> -->

<ngx-ui-loader></ngx-ui-loader>